export default __webpack_public_path__ + "static/media/kitchen3-afterF-1440w.f96ed7bd.avif";